export const buildAddress = (location, lineBreakAfterStreet = false) => {
  const { street_address, city_locality, state_region, postal_code } = location;
  let address = "";

  address += !!street_address ? `${street_address}, ${lineBreakAfterStreet ? "<br />" : ""}` : "";
  address += !!city_locality ? `${city_locality}, ` : "";
  address += !!state_region ? `${state_region} ` : "";
  address += !!postal_code ? `${postal_code}` : "";

  if (address === "") address = "Online only";

  return address;
};
